import { render, staticRenderFns } from "./ExhibitionView.vue?vue&type=template&id=3743c017&"
import script from "./ExhibitionView.vue?vue&type=script&lang=js&"
export * from "./ExhibitionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports